import { writable, get } from 'svelte/store';
export const AccountStore = writable(makeBaseAccount());
export const clearUser = () => {
    AccountStore.set({
        isLoggedIn: false
    });
};
export const setAccount = (account) => {
    AccountStore.set(account);
};
function makeBaseAccount() {
    return {
        isLoggedIn: false
    };
}
export function setAccountFromMSALResponse(accountInfo) {
    var _a, _b, _c;
    // console.log("setting Account from MSAL Response")
    let roles = [];
    roles = (_a = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.idTokenClaims) === null || _a === void 0 ? void 0 : _a.roles;
    let email = (_b = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.idTokenClaims) === null || _b === void 0 ? void 0 : _b.email;
    let account = {
        isLoggedIn: true,
        roles: roles !== null && roles !== void 0 ? roles : [],
        accountId: accountInfo.homeAccountId,
        username: accountInfo.username,
        name: accountInfo.name,
        email: (_c = email) !== null && _c !== void 0 ? _c : ""
    };
    // console.log(account)
    setAccount(account);
    return account;
}
